<template>
    <v-container>
        <v-layout>
            <v-flex xs12>
                <v-layout row wrap>
                    <v-flex xs12>
                        <OrderProgress
                            v-if="showingOrderProgress"
                            :stage="order.Stage"
                            :confirming="saving || loading"
                            :confirmError="saveError"
                            @onBack="goBack"
                        ></OrderProgress>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 v-if="!loading && loadError">
                        <v-card>
                            <v-alert outline :value="true" color="error" icon="error">
                                {{loadError}}
                            </v-alert>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 v-if="!loading && !loadError">
                        <PlaceOrder 
                            v-if="placingOrder" 
                            ref="placeOrder"
                            :loading="loading" 
                            :placing="saving"
                            :placeError="saveError"
                            @onSave="savedOrder"
                            @onConfirm="placedOrder"
                            @onPrintOrderSheet="printOrderSheet"
                        ></PlaceOrder>
                        <ConfirmOrder 
                            v-if="confirmingOrder" 
                            :loading="loading" 
                            :confirming="saving"
                            :confirmError="saveError"
                            :showStockEntry="showStockEntry"
                            @onCancel="goBack"
                            @onConfirm="confirmedOrder"
                        ></ConfirmOrder>
                        <SendOrder 
                            v-if="sendingOrder" 
                            :loading="loading" 
                            :sending="saving"
                            :sendError="saveError"
                            :showStockEntry="showStockEntry"
                            @onCancel="goBack"
                            @onConfirm="sendOrder"
                        ></SendOrder>
                        <CompleteOrder 
                            v-if="orderComplete" 
                            :loading="loading" 
                        ></CompleteOrder>
                        <PrintOrderSheet
                            v-if="printingOrderSheet"
                            :loading="loading"
                            :storeID="order.StoreID"
                            :departmentID="order.DepartmentID"
                            :date="order.Date"
                            :showStockEntry="showStockEntry"
                            @onCancel="cancelPrintOrderSheet">
                        </PrintOrderSheet>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-dialog
              v-model="successfulSaveDialog"
              max-width="290px"
              transition="dialog-transition"
            >
                <v-card class="no-padding">
                    <v-card-title class="headline">Order Saved</v-card-title>
                    <v-card-text>Order has been sucessfully saved.</v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat color="info" @click="successfulSaveDialog = false">OK</v-btn>
                    </v-card-actions>
                </v-card>
              
            </v-dialog>
        </v-layout>
    </v-container>
</template>

<script>
import OrderProgress from "./OrderProgress.vue";
import PlaceOrder from "./PlaceOrder.vue";
import ConfirmOrder from "./ConfirmOrder.vue";
import SendOrder from "./SendOrder.vue";
import CompleteOrder from "./CompleteOrder.vue";
import PrintOrderSheet from "./PrintOrderSheet.vue";
import util from '@/services/util';
import orderUtil from '@/services/orderUtil';

export default {
    components: {
        OrderProgress,
        PlaceOrder,
        ConfirmOrder,
        SendOrder,
        CompleteOrder,
        PrintOrderSheet
    },
    props: [
        'editOrderID'
    ],
    data() {
        return {
            viewPrintOrderSheet: false,
            successfulSaveDialog: false,
            showStockEntry:false,
        };
    },
    computed: {
        order(){
            return this.$store.state.placeOrderStore.order;
        },    
        orderProducts(){
            return this.$store.state.placeOrderStore.orderProducts;
        },
        showingOrderProgress(){
            return !this.viewPrintOrderSheet;
        },
        placingOrder(){
            return this.order.Stage == 0 && !this.viewPrintOrderSheet;
        },
        confirmingOrder(){
            return this.order.Stage == 1 && !this.viewPrintOrderSheet;
        },
        sendingOrder(){
            return this.order.Stage == 2 && !this.viewPrintOrderSheet;
        },
        orderComplete(){
            return this.order.Stage == 3 && !this.viewPrintOrderSheet;
        },
        printingOrderSheet(){
            return this.viewPrintOrderSheet;
        },
        loading() {
            return this.$store.state.placeOrderStore.loading;
        },
        loadError(){
            return this.$store.state.placeOrderStore.loadError;
        },
        saving() {
            return this.$store.state.placeOrderStore.saving.loading;
        },
        saveError() {
            return this.$store.state.placeOrderStore.saving.error;
        }
    },
    methods: {
        loadOrCreateOrder(editOrderID){
            let that = this;

            this.$store.dispatch("placeOrderStore/loadOrCreateOrder", {
                orderID: editOrderID
            });
        },
        printOrderSheet(showStockEntry){
            this.showStockEntry = showStockEntry;
            this.viewPrintOrderSheet = true;
        },
        cancelPrintOrderSheet(){
            this.viewPrintOrderSheet = false;
        },
        goBack(){
            this.$store.dispatch("placeOrderStore/clearSaveError");
            
            // Confirm -> Place and Send -> Place
            if(this.order.Stage == 1 || this.order.Stage == 2){
                this.order.Stage = 0;
            }
        },
        savedOrder(){
            let order = this.$store.getters["placeOrderStore/getOrderToSave"]();

            let that = this;
            this.$store.dispatch("placeOrderStore/saveOrder", {
                order: order,
                success: (savedOrder) => {
                    that.order.ID = savedOrder.ID;
                    that.successfulSaveDialog = true;
                }
            });
        },
        placedOrder(showStockEntry){
            this.showStockEntry = showStockEntry;
            let order = this.$store.getters["placeOrderStore/getOrderToSave"]();
            order.Stage = 1;

            let that = this;
            this.$store.dispatch("placeOrderStore/saveOrder", {
                order: order,
                success: (savedOrder) => {
                    that.order.ID = savedOrder.ID;
                    that.order.Stage = savedOrder.Stage;
                }
            });
        },
        confirmedOrder(){
            let order = this.$store.getters["placeOrderStore/getOrderToSave"]();
            order.Stage = 2;

            let that = this;
            this.$store.dispatch("placeOrderStore/saveOrder", {
                order: order,
                success: (savedOrder) => {
                    that.order.ID = savedOrder.ID;
                    that.order.Stage = savedOrder.Stage;
                }
            });
        },
        sendOrder(showStockEntry){
            this.showStockEntry = showStockEntry;
            let order = this.$store.getters["placeOrderStore/getOrderToSave"]();
            order.Stage = 3;

            let that = this;
            this.$store.dispatch("placeOrderStore/saveOrder", {
                order: order,
                success: (savedOrder) => {
                    that.order.ID = savedOrder.ID;
                    that.order.Stage = savedOrder.Stage;
                    that.order.SentDate = savedOrder.SentDate;
                }
            });
        },
    },
    created() {
        this.loadOrCreateOrder(this.editOrderID);
    }
};
</script>

<style>
.formSpacing {
    padding-left: 24px;
    padding-right: 24px;
}
</style>